import "./style.css";
import React from "react";

export default function ButtonAHSF(props) {
  return (
    <>
      {props.show && (
        <div>
          <button
            className="custom-button"
            type={props.type}
            onClick={props.onClick}
            disabled={props.disabled}
            title={props.title}
            id={props.id}
          >
            {props.text}
          </button>
        </div>
      )}
    </>
  );
}
